export default __webpack_public_path__ + "static/media/template2.36b50f84.svg";